"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_LOCALE = exports.SUPPORTED_LANGUAGES = exports.SUPPORTED_LOCALES = exports.LANGUAGE_TO_DEFAULT_LOCALE = exports.LanguageCode = exports.Locale = void 0;
var Locale;
(function (Locale) {
    Locale["arAR"] = "ar-AR";
    Locale["daDK"] = "da-DK";
    Locale["deDE"] = "de-DE";
    Locale["enGB"] = "en-GB";
    Locale["enUS"] = "en-US";
    Locale["esES"] = "es-ES";
    Locale["esMX"] = "es-MX";
    Locale["fiFI"] = "fi-FI";
    Locale["frFR"] = "fr-FR";
    Locale["itIT"] = "it-IT";
    Locale["jaJP"] = "ja-JP";
    Locale["nbNO"] = "nb-NO";
    Locale["nlNL"] = "nl-NL";
    Locale["ptBR"] = "pt-BR";
    Locale["svSE"] = "sv-SE";
    /** Psuedo-localized en-US */
    Locale["enPLOC"] = "en-PLOC";
})(Locale = exports.Locale || (exports.Locale = {}));
var LanguageCode;
(function (LanguageCode) {
    LanguageCode["ar"] = "ar";
    LanguageCode["da"] = "da";
    LanguageCode["de"] = "de";
    LanguageCode["en"] = "en";
    LanguageCode["es"] = "es";
    LanguageCode["fi"] = "fi";
    LanguageCode["fr"] = "fr";
    LanguageCode["it"] = "it";
    LanguageCode["ja"] = "ja";
    LanguageCode["nb"] = "nb";
    LanguageCode["nl"] = "nl";
    LanguageCode["pt"] = "pt";
    LanguageCode["sv"] = "sv";
})(LanguageCode = exports.LanguageCode || (exports.LanguageCode = {}));
/**
 * Default locales given language code
 */
exports.LANGUAGE_TO_DEFAULT_LOCALE = {
    [LanguageCode.ar]: Locale.arAR,
    [LanguageCode.da]: Locale.daDK,
    [LanguageCode.de]: Locale.deDE,
    [LanguageCode.en]: Locale.enUS,
    [LanguageCode.es]: Locale.esES,
    [LanguageCode.fi]: Locale.fiFI,
    [LanguageCode.fr]: Locale.frFR,
    [LanguageCode.it]: Locale.itIT,
    [LanguageCode.ja]: Locale.jaJP,
    [LanguageCode.nb]: Locale.nbNO,
    [LanguageCode.nl]: Locale.nlNL,
    [LanguageCode.pt]: Locale.ptBR,
    [LanguageCode.sv]: Locale.svSE,
};
/**
 * All locales for which we have translations
 */
exports.SUPPORTED_LOCALES = [
    Locale.arAR,
    Locale.daDK,
    Locale.deDE,
    Locale.enUS,
    Locale.enGB,
    Locale.esES,
    Locale.fiFI,
    Locale.frFR,
    Locale.itIT,
    Locale.jaJP,
    Locale.nbNO,
    Locale.nlNL,
    Locale.ptBR,
    Locale.svSE,
];
/**
 * All languages for which we have translations
 */
exports.SUPPORTED_LANGUAGES = [
    LanguageCode.ar,
    LanguageCode.da,
    LanguageCode.de,
    LanguageCode.en,
    LanguageCode.es,
    LanguageCode.fi,
    LanguageCode.fr,
    LanguageCode.it,
    LanguageCode.ja,
    LanguageCode.nb,
    LanguageCode.nl,
    LanguageCode.pt,
    LanguageCode.sv,
];
exports.DEFAULT_LOCALE = Locale.enUS;
//# sourceMappingURL=constants.js.map